import React, {  useState } from "react";
import '../index.css';
import '../UnauthorizedFooter.css';
import { useNavigate, Link } from "react-router-dom";

const UnauthorizedFooter = () => {
    const navigate = useNavigate();
     const [showPopup, setShowPopup] = useState(false);

         const handleSubscribe = (store) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      if (store === "android") {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.bossinvestor.app";
      } else if (store === "ios") {
        window.location.href =
          "https://apps.apple.com/us/app/example-app/id123456789"; // replace with real ID
      }
    } else {
      setShowPopup(true);
    }
  };

  return (
    <footer className="footer-dark py-3 bg-gray-800" >
      <div className="unauth-footer-container">


        {/* Left Section */}
        <div className="unauth-footer-left">
          <div className="unauth-footer-branding">
            <a href="/">
              <img 
                alt="BossInvestor Logo" 
                className="unauth-footer-logo" 
                src="/bossinvestorLogo.png" 
              />
            </a>
            <span className="unauth-footer-text">
              © 2025 BossInvestor Analytics Solutions Pvt. Ltd.
            </span>
          </div>

         
          <ul className="unauth-footer-links">
            <p style={{color:'white'}}>
              SEBI Registered Research Analyst No: INH000024143<br/>
              CIN	: U62099PN2025PTC237674
            </p>

            <div style={{display: "flex", gap: "80px"}}>

              {/* LEFT COLUMN — SUPPORT */}
              <div>
                <h4 style={{color:'white', fontSize:'16px', marginBottom:'10px'}}>Support</h4>

                <li>
                  <Link to="/contact" className="text-gray-400 hover:text-white">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to="/complianceredressal" className="text-gray-400 hover:text-white">
                    Compliance Redressal
                  </Link>
                </li>
                <li>
                  <Link to="/shipping" className="text-gray-400 hover:text-white">
                    Shipping
                  </Link>
                </li>
                <li>
                  <Link to="/escalation_matrix" className="text-gray-400 hover:text-white">
                    Escalation Matrix
                  </Link>
                </li>
                <li>
                  <a
                    href="https://smartodr.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className="text-gray-400 hover:text-white"
                  >
                    Smart ODR
                  </a>
                </li> 

              </div>

              {/* RIGHT COLUMN — COMPANY */}
              <div>
                <h4 style={{color:'white', fontSize:'16px', marginBottom:'10px'}}>Company</h4>

                <li>
                  <Link to="/terms-and-conditions" className="text-gray-400 hover:text-white">
                    Terms & Conditions
                  </Link>
                </li>

                <li>
                  <Link to="/privacy-policy" className="text-gray-400 hover:text-white">
                    Privacy Policy
                  </Link>
                </li>

                <li>
                  <Link to="/about" className="text-gray-400 hover:text-white">
                    About Us
                  </Link>
                </li>

                <li>
                  <Link to="/cancellationrefunds" className="text-gray-400 hover:text-white">
                    Cancellation Refunds
                  </Link>
                </li>

                <li>
                  <Link to="/investor_charter" className="text-gray-400 hover:text-white">
                    Investor Charter
                  </Link>
                </li>
                <li>
                  <Link to="/investor_monthly_complaints" className="text-gray-400 hover:text-white">
                    Investor Monthly Complaints
                  </Link>
                </li>
              </div>

            </div>
          </ul>

        </div>

        {/* Right Section */}
        <div className="unauth-footer-right">
          {/* App Store Badges */}
          <div className="store-badges">
            <a
              // href="https://play.google.com/store"
              target="_blank"
              onClick={() => handleSubscribe("android")}
              rel="noopener noreferrer"
            >
              <img src="/google-play-badge.png" alt="Google Play Store" />
            </a>
            <a
              // href="https://www.apple.com/app-store/"
              target="_blank"
              onClick={() => handleSubscribe("ios")}
              rel="noopener noreferrer"
            >
              <img src="/apple-store-badge.png" alt="Apple App Store" />
            </a>
          </div>

          {/* Social Icons */}
          <div className="social-icons" style={{marginTop:'2px !important' }}>
            <a href="https://x.com/BossInvestor24" target="_blank" rel="noopener noreferrer" className="twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://www.linkedin.com/company/bossinvestor2024/"  target="_blank" rel="noopener noreferrer" className="linkedin">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://www.youtube.com/@BossInvestor" className="youtube" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://t.me/bossinvestor24" className="telegram" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div>
            <p
              className="footer-note"
              style={{
                fontSize: "12px",
                paddingTop: "65px",
                color: "rgb(156 163 175)",
                textAlign: "center",
                lineHeight: "18px"
              }}
            >
              The information provided by BossInvestor through its website is for informational 
              and educational purposes only and is not a solicitation to buy any of our products.
            </p>
          </div>

        </div>
      </div>
      {showPopup && (
        <div className="qr-overlay" onClick={() => setShowPopup(false)}>
          
          <div className="qr-modal" onClick={(e) => e.stopPropagation()}>

            <button className="qr-close-icon" onClick={() => setShowPopup(false)}>
              ✕
            </button>

            <h2 className="qr-title">Get the Bossinvestor App</h2>
            <img 
              src="/playstoreScanner.jpeg" 
              alt="QR Code" 
              style={{ width: "170px", height: "170px", borderRadius: "12px" }}
            />
            <p className="qr-subtitle">
              Scan the QR code to download the app
            </p>

          </div>
        </div>
      )}
    </footer>
  );
};

export default UnauthorizedFooter;
